import { createAction } from '@reduxjs/toolkit';
import { SET_THREADS_SUCCESS } from '../constants/actionTypes';
export const setThreadsSuccess = createAction(SET_THREADS_SUCCESS);